import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import { Link } from "react-router-dom";

const BANDS = [
  { r: "$20,000 – $40,000", label: "Considered", d: "A refined single-material wall with integrated TV, discreet cabinetry and considered lighting." },
  { r: "$40,000 – $75,000", label: "Signature", d: "Multi-material composition with integrated fireplace, joinery and material feature zones." },
  { r: "$75,000 – $120,000+", label: "Editorial", d: "A full architectural gesture — book-matched stone, custom joinery, curved forms, complete AV integration." },
];

export default function InvestmentPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="investment-page">
      <PublicNav/>
      <section className="pt-32 pb-16 px-6 lg:px-12 max-w-4xl mx-auto">
        <div className="overline">Investment</div>
        <h1 className="font-serif font-light mt-4" style={{ fontSize: "clamp(44px, 6vw, 68px)", lineHeight: 1.05 }}>A considered investment.</h1>
        <p className="text-muted-foreground mt-6 leading-relaxed text-lg">
          Every Luxe Media Walls project is bespoke. The investment reflects the materials, complexity, joinery, integration and installation scope of your particular wall. The bands below give a realistic sense of scale — a detailed proposal follows your consultation.
        </p>
      </section>
      <section className="max-w-6xl mx-auto px-6 lg:px-12 pb-24">
        <div className="grid md:grid-cols-3 gap-px bg-border border border-border">
          {BANDS.map((b) => (
            <div key={b.label} className="bg-card p-10">
              <div className="overline text-[10px]" style={{ color: "#A68A64" }}>{b.label}</div>
              <div className="font-serif text-3xl mt-3">{b.r}</div>
              <p className="text-muted-foreground mt-4 text-sm">{b.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-16 text-center">
          <Link to="/enquiry" data-testid="btn-investment-enquire" className="btn-accent inline-flex" style={{ padding: "16px 28px" }}>Request a detailed proposal</Link>
        </div>
      </section>
      <PublicFooter/>
    </div>
  );
}
